import { Component, OnDestroy } from '@angular/core';
import { EComService } from '@src/app/ecom-services/ecom-common.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { SocialAuthModel, SocialKind } from '../socials.model';
import { SocialsService } from '../socials.service';
import { FacebookAuthService } from './facebook-auth.service';
@Component({
  selector: 'app-facebook-login',
  templateUrl: './facebook-auth.component.html',
  styleUrls: ['./facebook-auth.component.css']  // Add this line
})

export class FacebookAuthComponent implements OnDestroy  { 
     
  userProfile:any;//= {AuthId:'',Email:'',FirstName:'',LastName:'',UserFullName:''};
  isAuthenticated: boolean = false;
  urlAvartar:string ="";
  private readonly ngUnsubscribe = new Subject();
  constructor(private readonly _fbAuthService: FacebookAuthService,
              private readonly _socialGlobal: SocialsService,
            public ecomservice: EComService) 
  { 
    this._fbAuthService.authStatus
    .pipe(takeUntil(this.ngUnsubscribe))
    .subscribe(status => {
      if (status) {
        this.isAuthenticated = true;
        this.loadingData(); 
      } else {
        this.isAuthenticated = false; 
        this._socialGlobal.authObjectSubject.next(null);  
      }
    });
    this.urlAvartar = `${window.location.origin}/${this.ecomservice.GetOlarConfigValue('PREFIX_ROUTING')}assets/icon/user-sm.svg`;
  }

  ngOnDestroy() { 
    this.ngUnsubscribe.complete();  
  } 

  private async loadingData():Promise<void> {
   
    const profile:any  = await this._fbAuthService.getUserProfile();  
    this.userProfile = profile;
    this.urlAvartar = this.userProfile.picture.data.url; 
    const facebookProfile:SocialAuthModel = {AuthId: profile.id, Email: profile.email, FirstName: profile.first_name,LastName: profile.last_name, UserFullName: profile.name}; 
    this._socialGlobal.authObjectSubject.next({ KindId: SocialKind.Facebook, UserInfo: facebookProfile });
  }
  

  login() {
    this._fbAuthService.login(); 
  } 

  logout() {
    this._fbAuthService.logout();
  } 

  public avartarLoadError(event:any){ 
    this.urlAvartar = this.userProfile.picture.data.url; 
  }
}